import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = /*#__PURE__*/_createVNode("div", { class: "mb-10" }, [
  /*#__PURE__*/_createVNode("h1", { class: "anchor fw-bolder mb-5" }, [
    /*#__PURE__*/_createVNode("a", { href: "#table" }),
    /*#__PURE__*/_createTextVNode(" Table ")
  ]),
  /*#__PURE__*/_createVNode("div", { class: "py-5" }, " Display multiple data with similar format. You can sort, filter, compare your data in a table. ")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_EUIBasicTable = _resolveComponent("EUIBasicTable")
  const _component_EUIStripedTable = _resolveComponent("EUIStripedTable")
  const _component_EUITableWithBorder = _resolveComponent("EUITableWithBorder")
  const _component_EUITableWithStatus = _resolveComponent("EUITableWithStatus")
  const _component_EUITableWithFixedHeader = _resolveComponent("EUITableWithFixedHeader")
  const _component_EUITableWithFixedColumn = _resolveComponent("EUITableWithFixedColumn")
  const _component_EUITableWithFixedColumnsAndHeader = _resolveComponent("EUITableWithFixedColumnsAndHeader")
  const _component_EUIFluidHeightTableWithFixedHeaderAndColumns = _resolveComponent("EUIFluidHeightTableWithFixedHeaderAndColumns")
  const _component_EUIGroupingTableHead = _resolveComponent("EUIGroupingTableHead")
  const _component_EUISingleSelect = _resolveComponent("EUISingleSelect")
  const _component_EUIMultipleSelect = _resolveComponent("EUIMultipleSelect")
  const _component_EUISorting = _resolveComponent("EUISorting")
  const _component_EUIFilter = _resolveComponent("EUIFilter")
  const _component_EUICustomColumnTemplate = _resolveComponent("EUICustomColumnTemplate")
  const _component_EUITableWithCustomHeader = _resolveComponent("EUITableWithCustomHeader")
  const _component_EUIExpandableRow = _resolveComponent("EUIExpandableRow")
  const _component_EUITreeDataAndLazyMode = _resolveComponent("EUITreeDataAndLazyMode")
  const _component_EUISummaryRow = _resolveComponent("EUISummaryRow")
  const _component_EUIRowspanAndColspan = _resolveComponent("EUIRowspanAndColspan")
  const _component_EUICustomIndex = _resolveComponent("EUICustomIndex")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _hoisted_1,
    _createVNode(_component_EUIBasicTable),
    _createVNode(_component_EUIStripedTable),
    _createVNode(_component_EUITableWithBorder),
    _createVNode(_component_EUITableWithStatus),
    _createVNode(_component_EUITableWithFixedHeader),
    _createVNode(_component_EUITableWithFixedColumn),
    _createVNode(_component_EUITableWithFixedColumnsAndHeader),
    _createVNode(_component_EUIFluidHeightTableWithFixedHeaderAndColumns),
    _createVNode(_component_EUIGroupingTableHead),
    _createVNode(_component_EUISingleSelect),
    _createVNode(_component_EUIMultipleSelect),
    _createVNode(_component_EUISorting),
    _createVNode(_component_EUIFilter),
    _createVNode(_component_EUICustomColumnTemplate),
    _createVNode(_component_EUITableWithCustomHeader),
    _createVNode(_component_EUIExpandableRow),
    _createVNode(_component_EUITreeDataAndLazyMode),
    _createVNode(_component_EUISummaryRow),
    _createVNode(_component_EUIRowspanAndColspan),
    _createVNode(_component_EUICustomIndex)
  ], 64))
}